import template from './form.html';
import { FormActions } from 'core/services/form';
import tiposAtributoClienteI18N from 'i18n/tipos-atributo-cliente/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';

export let TipoAtributoClienteFormComponent = {
  templateUrl: template,
  selector: 'tipoAtributoClienteForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(tiposAtributoClienteI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', '$timeout', '$scope'];

function FormController($state, $ngRedux, ngNotify, $stateParams, $timeout, $scope) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  this.onTagRemoving = onTagRemoving.bind(this);
  this.tagClass = tagClass.bind(this);

  let unsubscribe;

  this.localModel = {
    camposOpcionales: [],
    camposRequeridos: []
  };

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.create = false;
      if (this.view) {
        this.edit = false;
        this.title = this.translations['Ver tipo de atributo de cliente'];
      } else {
        this.edit = true;
        this.title = this.translations['Editar tipo de atributo de cliente'];
      }
      this.formEdit('tipos-atributos-cliente', $stateParams.uid);

    } else {
      this.create = true;
      this.edit = false;
      this.title = this.translations['Nuevo tipo de atributo de cliente'];
      this.form();
    }
  };


  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.model = state.form.model;

    if (this.model && this.model.id) {
      this.cantCampos = Object.keys(this.model.campos).length;
      // Si es la primera vez que carga, inicializar los campos requeridos y opcionales
      if (this.localModel.camposRequeridos.length === 0) {
        this.localModel.camposRequeridos = this.model.campos.filter(campo => campo.required);
        this.localModel.camposOpcionales = this.model.campos.filter(campo => !campo.required);
      }
    }

    return {
      form: state.form
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.tipos-atributo-cliente.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      $state.go('home.tipos-atributo-cliente.list');
    }

    if (state.sucursales.error) {
      ngNotify.set(state.sucursales.error.message, 'error');
    }

    if (state.roles.error) {
      ngNotify.set(state.roles.error.message, 'error');
    }
  }


  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.tipos-atributo-cliente.list');
  }

  function doSubmit() {
    if ($scope.tipoAtributoClienteForm.$invalid) {
      this.submitted = true;
      return;
    }
    let data = Object.assign({}, this.model);
    this.save('tipos-atributos-cliente', data);
  }

  function onTagRemoving(tag) {
    return !(tag.removable !== undefined && !tag.removable);
  }

  /**
   * Obtener las clases a aplicar a los tags.
   * @param tag Campo representado por el tag cuyas clases se desea saber.
   */
  function tagClass(tag) {
    const classes = [];
    // debe estar desactivado si:
    // esta en modo view, o
    // no esta en modo create (por ende esta en edicion), y el campo tiene la propiedad removable y es false
    const disabled = this.view
      || (!this.create && tag.removable !== undefined && !tag.removable);
    classes.push(disabled? 'tagitemdisabled' : '');

    return classes;
  }

}



// WEBPACK FOOTER //
// ./src/components/tipos-atributo-cliente/form/form.component.js